// Mock data for UBITZ.AI website
// This file contains all mock data used in the frontend
// Remove this file and integrate with backend API later

export const mockData = {
  stats: [
    { value: '200+', label: 'Transformation Programs' },
    { value: '40+', label: 'Enterprise Clients' },
    { value: '5,000+', label: 'Global Experts' },
    { value: '97%', label: 'Engagement Retention Rate' }
  ],
  
  testimonials: [
    {
      quote: "Ubitz.ai transformed our entire IT infrastructure. Their AI-driven approach saved us millions.",
      author: "Sarah Johnson",
      role: "CTO, Fortune 500 Tech Company",
      company: "TechCorp Global"
    },
    {
      quote: "The staffing solutions are unmatched. We found the perfect talent in record time.",
      author: "Michael Chen",
      role: "VP Engineering",
      company: "InnovateLabs"
    },
    {
      quote: "Their consulting expertise helped us achieve digital transformation goals 6 months ahead of schedule.",
      author: "Emily Rodriguez",
      role: "Chief Digital Officer",
      company: "Global Finance Inc"
    }
  ],

  knowledgeArticles: [
    {
      id: 1,
      title: 'The Rise of Autonomous IT',
      excerpt: 'Exploring how AI is reshaping IT operations and creating self-healing systems.',
      category: 'AI & Automation',
      readTime: '8 min',
      date: '2025-01-15'
    },
    {
      id: 2,
      title: 'Cognitive Workforces and Human-AI Harmony',
      excerpt: 'Understanding the future of work where humans and AI collaborate seamlessly.',
      category: 'Future of Work',
      readTime: '12 min',
      date: '2025-01-10'
    },
    {
      id: 3,
      title: 'The Ethics of Synthetic Decisioning',
      excerpt: 'Navigating the ethical implications of AI-driven decision making in enterprises.',
      category: 'Ethics',
      readTime: '10 min',
      date: '2025-01-05'
    }
  ],

  industries: [
    { name: 'Healthcare & Life Sciences', clients: 15 },
    { name: 'Financial Services', clients: 12 },
    { name: 'Manufacturing', clients: 8 },
    { name: 'Telecom & Infrastructure', clients: 10 },
    { name: 'Technology & Startups', clients: 18 }
  ],

  contactSubmissions: []
};

export default mockData;